import React from 'react';
import RouteLoadingContainer from '../../atoms/RouteLoadingContainer';
import RouteLoadingSpinner from '../../atoms/RouteLoadingSpinner';
import RouteLoadingText from '../../atoms/RouteLoadingText';
import MDBox from '../../../shared/atoms/MDBox';

interface RouteLoadingStateProps {
  message?: string;
  spinnerSize?: number;
  fullScreen?: boolean;
  textVariant?: 'h6' | 'body1' | 'body2';
}

const RouteLoadingState: React.FC<RouteLoadingStateProps> = ({
  message = 'Loading...',
  spinnerSize = 60,
  fullScreen = true,
  textVariant = 'h6'
}) => {
  return (
    <RouteLoadingContainer fullScreen={fullScreen}>
      <MDBox mb={2}>
        <RouteLoadingSpinner size={spinnerSize} />
      </MDBox>
      <RouteLoadingText message={message} variant={textVariant} />
    </RouteLoadingContainer>
  );
};

export default RouteLoadingState;